import _ from 'lodash'

/**
 * 判断数组arr中是否包含项item
 * @param arr
 * @param item
 * @returns {boolean}
 */
export const contains = (arr, item) => {
  if (_.isEmpty(arr)) {
    console.log('arr is empty.');
    return false;
  }
  if (_.isEmpty(item)) {
    console.log('item is empty.');
    return false;
  }
  if (!_.isArray(arr)) {
    console.log('arr is not Array.');
    return false;
  }

  for (let val of arr) {
    if (_.isEqual(val, item)) {
      return true;
    }
  }
  return false;
}

